module.exports = __webpack_public_path__ + "static/banner-bc0d9513975cd70a87f1384b9945cafd.jpg";